var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useMemo, useRef } from 'react';
import createStore from 'redux-zero';
import { useSelector, Provider } from 'redux-zero/react';
import { RenderStore, isCircleComp } from '@tencent/gems-renderer-core';
export var defaultRenderStore = new RenderStore(createStore({}));
export var RenderStoreContext = React.createContext(defaultRenderStore);
export var useRenderStore = function () {
    return useContext(RenderStoreContext);
};
var RenderStoreProvider = /** @class */ (function (_super) {
    __extends(RenderStoreProvider, _super);
    function RenderStoreProvider(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.state = {
            renderStore: (_a = props.renderStore) !== null && _a !== void 0 ? _a : new RenderStore(createStore({})),
        };
        return _this;
    }
    // 在预览太切换协议,返回编辑态应重置store
    RenderStoreProvider.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.renderStore && nextProps.renderStore !== prevState.renderStore) {
            return {
                renderStore: nextProps.renderStore,
            };
        }
        return null;
    };
    RenderStoreProvider.prototype.render = function () {
        var children = this.props.children;
        var renderStore = this.state.renderStore;
        return (React.createElement(RenderStoreContext.Provider, { value: renderStore },
            React.createElement(Provider, { store: renderStore.rootStore }, children)));
    };
    return RenderStoreProvider;
}(React.Component));
export { RenderStoreProvider };
/**
 * @description: 处理当前schema的store
 * @param {string[]} relativeStoreIds 相关联的storeId
 * @param {ComponentInstance | ActionInstance} instance
 * @param {IIterator} iterator
 * @return {any}
 */
export var useSchemaStore = function (relativeStoreIds, instance, iterator) {
    var _a;
    var renderStore = useRenderStore();
    var schemaRelativeStateRef = useRef({});
    var key = instance.key, _b = instance.component, _c = _b === void 0 ? {} : _b, _d = _c.store, store = _d === void 0 ? {} : _d, action = instance.action;
    // 若为action的store
    if (action) {
        store = action === null || action === void 0 ? void 0 : action.store;
    }
    /**
     * 为循环组件创建storestate，放在对应key的state数组中
     * eg: 3:[{a: 1},{a: 2}]
     */
    if (isCircleComp(iterator)) {
        renderStore.registerCircleSchemaStore(store, instance, iterator);
    }
    // 关联依赖的store，检查前后是否有变化
    var schemaRelativeState = useSelector(function (state) {
        var _a = relativeStoreIds.reduce(function (result, k) {
            var _a;
            return {
                hadChange: result.hadChange || schemaRelativeStateRef.current[k] !== state[k],
                relativeState: __assign(__assign({}, result.relativeState), (_a = {}, _a[k] = state[k], _a)),
            };
        }, { hadChange: false, relativeState: {} }), hadChange = _a.hadChange, relativeState = _a.relativeState;
        if (hadChange) {
            schemaRelativeStateRef.current = relativeState;
        }
        return schemaRelativeStateRef.current;
    });
    var schemaAction = useMemo(function () {
        return renderStore.actions[key]
            ? Object.entries(renderStore.actions[key]).reduce(function (mapToActions, _a) {
                var _b = __read(_a, 2), action = _b[0], actionHandler = _b[1];
                mapToActions[action] = renderStore.bindAction(key, actionHandler, iterator);
                return mapToActions;
            }, {})
            : {};
    }, [key, renderStore.actions[key], JSON.stringify(iterator)]);
    // 循环组件对应的action应该存在对应的iterator中
    if (isCircleComp(iterator)) {
        renderStore.bindedActions[key] = __assign(__assign({}, renderStore.bindedActions[key]), (_a = {}, _a[iterator === null || iterator === void 0 ? void 0 : iterator.index] = schemaAction, _a));
    }
    else {
        renderStore.bindedActions[key] = schemaAction;
    }
    // 拿取自身state
    var schemaState = isCircleComp(iterator)
        ? schemaRelativeState[key][iterator === null || iterator === void 0 ? void 0 : iterator.index]
        : schemaRelativeState[key];
    // schemaStore 平铺了组件的state和actions
    var schemaStore = __assign(__assign(__assign({}, schemaState), schemaAction), { key: key });
    return schemaStore;
};
//# sourceMappingURL=context.js.map